import { useUserStore } from '~/stores/user'
import { useBubblesStore } from '~/stores/bubbles'
import { useOnboardingStore } from '~/stores/onboardingStore'
import { logError, warn } from '~/composables/useLogger'
import * as Session from 'supertokens-web-js/recipe/session'

export default defineNuxtPlugin(async (nuxtApp) => {
  if (import.meta.server) return

  const userStore = useUserStore()
  const bubblesStore = useBubblesStore()
  const onboardingStore = useOnboardingStore()

  const loadInitialData = async () => {
    try {
      // Use a more reliable flag to prevent refetching all data
      if (userStore.initialDataLoaded) {
        return
      }

      const sessionExists = await Session.doesSessionExist()
      if (!sessionExists) {
        warn('No user session found. Skipping initial data load.')
        return
      }

      // Load user profile first
      if (!userStore.profileFetched) {
        await userStore.fetchUserProfile()
      }

      // If there's no user, no need to fetch other data
      if (!userStore.user) {
        warn('No user session found. Skipping initial data load.')
        return
      }

      // Now, fetch other essential data in parallel
      await Promise.all([
        userStore.fetchUserStats(),
        bubblesStore.fetchLiteBubbles(),
        bubblesStore.fetchBubbleTypes(),
        bubblesStore.fetchUserBubbleTypes(),
        onboardingStore.loadFromCookie(),
      ])

      // Set the flag to indicate all initial data is loaded
      userStore.initialDataLoaded = true
    } catch (error) {
      logError('Error loading initial data in plugin:', error)
    }
  }

  // Load data on initial app load
  await loadInitialData()

  // You can also provide a helper to reload data if needed
  nuxtApp.provide('loadInitialData', loadInitialData)
})
